<template>
  <div class="business-contact-agency-page">
    <div class="alert alert-warning mt-5" role="alert">
      Your account is not currently subscribed. Please reach out to your agency administrator for assistance.
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  }
}
</script>

<style scoped>
.business-contact-agency-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
</style>

